import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom';
import {router} from "./App"
import * as Sentry from "@sentry/react";
import ErrorBoundary from './components/ErrorBoundary';
// De vaste teksten van de widget. Stond hier niet, waardoor i18next nooit werd opgestart en
// elke t() de sleutel zelf teruggaf. (WI1)
import './i18n';
// De instellingen op één plek. Vite kent process.env niet; daar heet het import.meta.env, en dat
// lezen gebeurt nu in dit ene bestand in plaats van op 21 plekken. (WI11)
import {
    apiAdres, omgeving, versie, sentryAdres,
    sentryMeetdeel, sentryOpnamedeel, sentryFoutopnamedeel,
    instellingenNakijken,
} from './instellingen';

instellingenNakijken();

const apiUrl = apiAdres.trim().replace(/\/$/, '');

Sentry.init({
  dsn: sentryAdres,
  environment: omgeving,
  release: versie,
  // Uit. Met deze schakelaar stuurt Sentry het ip-adres en alles wat hij aan de gast kan koppelen
  // mee. In een boekwidget is dat naam, e-mailadres en telefoonnummer van iemand die alleen een
  // tafel wilde reserveren. (WI7, besloten met Martijn 13-09-2026.)
  sendDefaultPii: false,

  integrations: [
    Sentry.browserTracingIntegration(),

    // De sessieopname speelt terug wat de gast op het scherm deed. Zonder afschermen zie je hem
    // letterlijk zijn naam, e-mailadres en telefoonnummer intypen -- daar heb je geen grondslag
    // voor. Met afschermen zie je nog steeds de vorm van het scherm, de klikken en het foutpad, en
    // in de praktijk is dat waar je een fout mee oplost.
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
      maskAllInputs: true,
    }),
  ],

  // Capture 20% of transactions for performance monitoring (tune per environment)
  tracesSampleRate: sentryMeetdeel,

  // Propagate Sentry trace headers to the Jimani API so back-end errors link to front-end traces
  tracePropagationTargets: [
    'localhost',
    ...(apiUrl ? [new RegExp(`^${apiUrl.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`)] : []),
  ],

  // Record 10% of sessions; always record sessions where an error occurred
  replaysSessionSampleRate: sentryOpnamedeel,
  replaysOnErrorSampleRate: sentryFoutopnamedeel,
});
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <ErrorBoundary >
   <RouterProvider router={router} />
   </ErrorBoundary>
  // </React.StrictMode>
);
reportWebVitals();
